import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import PayPalButtonsWrapper from './PayPalButtonsWrapper';
import ApiService from '../../services/ApiService';
import { decrypt } from "../../utils/crypto";

function PaypalPayment() {
    const location = useLocation();
    const [clientId, setClientId] = useState(null);

    const getPaypalKey = async () => {
        try {
            var response = await new ApiService().GET(`/get-credential-keys/paypal`);
            if (response.data.status === '1') {
                const dec_client_id = decrypt(response.data.client_id, process.env.REACT_APP_CRYPTO_KEY);
                setClientId(dec_client_id);
            } else {
                console.log(response.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getPaypalKey();
    }, []);

    return (
        <>
            {clientId !== null && (
                <PayPalButtonsWrapper
                    payment_type={location.state?.payment_type || "recharge"}
                    amount={location.state?.amount}
                    clientId={clientId}
                    chat_plan_id={location.state?.chat_plan_id ? location.state.chat_plan_id : ""}
                />
            )}
        </>
    );
}

export default PaypalPayment;
